'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  margin-right: -8px;\n  margin-left: -4px;\n'], ['\n  margin-right: -8px;\n  margin-left: -4px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin: 0;\n'], ['\n  margin: 0;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  background: none;\n  border: none;\n  text-align: left;\n  padding: 0;\n'], ['\n  background: none;\n  border: none;\n  text-align: left;\n  padding: 0;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _HR = require('UIComponents/elements/HR');

var _HR2 = _interopRequireDefault(_HR);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _UIBox = require('UIComponents/layout/UIBox');

var _UIBox2 = _interopRequireDefault(_UIBox);

var _UIStatusTag = require('UIComponents/tag/UIStatusTag');

var _UIStatusTag2 = _interopRequireDefault(_UIStatusTag);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var IndicatorWrapper = (0, _styledComponents2.default)(_UIBox2.default).withConfig({
  displayName: 'ThreadListItemWrapper__IndicatorWrapper'
})(_templateObject);

var TheadListItemBreak = (0, _styledComponents2.default)(_HR2.default).withConfig({
  displayName: 'ThreadListItemWrapper__TheadListItemBreak'
})(_templateObject2);

var ItemButton = _styledComponents2.default.button.withConfig({
  displayName: 'ThreadListItemWrapper__ItemButton'
})(_templateObject3);

function ThreadListItemWrapper(_ref) {
  var coloring = _ref.coloring,
      nameText = _ref.nameText,
      onClick = _ref.onClick,
      renderAvatar = _ref.renderAvatar,
      renderText = _ref.renderText,
      renderTimestamp = _ref.renderTimestamp,
      unseenCount = _ref.unseenCount;

  return _react2.default.createElement(
    ItemButton,
    {
      className: 'selenium-test-marker-thread-list-item thread-list-item p-x-5 p-top-2',
      role: 'button',
      type: 'button',
      onClick: onClick
    },
    _react2.default.createElement(
      'div',
      { className: 'display-flex p-y-1' },
      _react2.default.createElement(
        IndicatorWrapper,
        { alignSelf: 'center' },
        _react2.default.createElement(_UIStatusTag2.default, {
          inline: true,
          color: unseenCount ? coloring.get('accentColor') : 'transparent'
        })
      ),
      _react2.default.createElement(
        'div',
        {
          className: 'display-flex justify-center m-right-3',
          style: { minWidth: 48 }
        },
        renderAvatar()
      ),
      _react2.default.createElement(
        'div',
        { style: { flexGrow: 1 } },
        _react2.default.createElement(
          _Small2.default,
          { className: 'justify-between', use: 'help' },
          _react2.default.createElement(
            'span',
            null,
            nameText
          ),
          renderTimestamp()
        ),
        renderText()
      )
    ),
    _react2.default.createElement(TheadListItemBreak, { className: 'thread-separator', distance: 'small' })
  );
}

ThreadListItemWrapper.displayName = 'ThreadListItemWrapper';

ThreadListItemWrapper.propTypes = {
  coloring: (0, _RecordPropType2.default)('ColoringRecord').isRequired,
  nameText: _react.PropTypes.string.isRequired,
  onClick: _react.PropTypes.func.isRequired,
  renderAvatar: _react.PropTypes.func.isRequired,
  renderText: _react.PropTypes.func.isRequired,
  renderTimestamp: _react.PropTypes.func.isRequired,
  unseenCount: _react.PropTypes.number
};

exports.default = ThreadListItemWrapper;
module.exports = exports['default'];